import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// translation files
import common_en from 'translations/en/translation.json';
import common_pl from 'translations/pl/translation.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pl",
    supportedLngs: ["pl", "en"],
    debug: false,
    detection: {
      order: ["localStorage", "cookie"],
      chaches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      pl: {
        common: common_pl
      },
      en: {
        common: common_en
      },
    },
  });

const setHtmlLang = (lng) => {
  document.documentElement.lang = (lng || 'pl').split('-')[0];
};
setHtmlLang(i18n.language);
i18n.on('languageChanged', setHtmlLang);

export default i18n;
